import React from 'react';
import colors from '../../util/colors';
import AppDownloadButton from '../app-download-button';
import {Column, Row} from '../layout';
import * as fonts from '../../../src/util/fonts';
import {getBlob} from '../../api/api';
import {
  uriGetSinisterDocumentDownload,
  uriGetTheIRSpdf,
} from '../../api/endpoints';
import './styles.scss';
import {strings} from '../../util/strings';
import Icon from '../icon';
import {Icons} from '../../util/icons';
import {addToWizard} from '../../store/actions';
import {compose} from 'redux';
import {connect} from 'react-redux';
import RenderDocument from './RenderDocument';

export interface submittedFile {
  id: any;
  name: string;
  url: string;
  code?: string;
  description: string;
  path?: string;
}

export interface ContainerEmittedDocumentsProps {
  submittedFiles?: submittedFile[];
  labels: typeof strings.pt.preAuthorizations;
  labelsIrs: typeof strings.pt.IRS;
  title: string;
  buStyles: any;
  selectedBu: any;
  documentIds?: any[];
  isIrsDeclaration?: boolean;
  isNotDownloadable?: boolean;
  setShowError?: any;
}

function ContainerEmittedDocuments({
  submittedFiles,
  labels,
  labelsIrs,
  selectedBu,
  title,
  buStyles,
  documentIds,
  isIrsDeclaration,
  isNotDownloadable,
  setShowError,
}: ContainerEmittedDocumentsProps) {
  const featureName = 'DownloadIrsPdf';

  //chamada api para ir buscar o pdf e fazer download
  async function documentDownload(item: any) {
    let response: any;
    try {
      if (item.isExpense) {
        response = await getBlob(uriGetSinisterDocumentDownload(item.id));
      } else {
        response = await getBlob(
          uriGetTheIRSpdf(
            selectedBu.buId,
            selectedBu.memId,
            item.year.toString(),
            item?.split
          ),
          false,
          true,
          featureName
        );
      }
    } catch (err: any) {
      setShowError(true);
      return;
    }

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(response);
    link.setAttribute(
      'download',
      item.description ||
        item.path ||
        `${labelsIrs.IRS_documentTitle} ${' '} ${item.year}` + '.pdf'
    );

    document.body.appendChild(link);

    link.click();

    link.parentNode?.removeChild(link);
  }

  return (
    <Column className="container-document-dowmload-success-file-column">
      <Row
        className="reimbursement-success-file-title-row-doc-download m-0"
        style={{...fonts.MM, color: colors.black}}>
        {title}
      </Row>
      {submittedFiles && (
        <Row className="container-document-download m-0">
          {submittedFiles.map((item) => (
            <>
              {!isNotDownloadable && (
                <a target="_blank" href={item.url} className="anchor m-0">
                  <Row className="reimbursement-success-file">
                    <Icon
                      className="reimbursement-success-file-icon"
                      style={{margin: '1rem'}}
                      name={Icons.DECLARATIONS}
                      width={'26'}
                      height={'26'}
                      changeViewbox
                      viewBox={'0 0 24 24'}
                    />
                    <Column
                      className="reimbursement-success-file-title"
                      style={{...fonts.M, ...fonts.Medium}}>
                      {item.description ? item.description : item.path}
                    </Column>

                    <AppDownloadButton
                      color={buStyles?.primaryColor || colors.blue}
                    />
                  </Row>
                </a>
              )}
              {isNotDownloadable && (
                <Row className="reimbursement-success-file">
                  <Icon
                    className="reimbursement-success-file-icon"
                    style={{margin: '1rem'}}
                    name={Icons.DECLARATIONS}
                    width={'26'}
                    height={'26'}
                    changeViewbox
                    viewBox={'0 0 24 24'}
                  />
                  <Column
                    className="reimbursement-success-file-title"
                    style={{...fonts.M, ...fonts.Medium}}>
                    {item.description ? item.description : item.path}
                  </Column>
                </Row>
              )}
            </>
          ))}
        </Row>
      )}
      {documentIds && (
        <Row className="container-document-download m-0">
          {documentIds
            .sort((a, b) => (a.year < b.year ? 1 : -1))
            .map((item) =>
              isIrsDeclaration ? (
                <Row className="render-document-row">
                  <RenderDocument
                    item={item}
                    documentDownload={documentDownload}
                    isIrsDeclaration={isIrsDeclaration}
                  />
                </Row>
              ) : (
                <RenderDocument
                  item={item}
                  documentDownload={documentDownload}
                  isIrsDeclaration={isIrsDeclaration}
                />
              )
            )}
        </Row>
      )}
    </Column>
  );
}

const mapStateToProps = ({selectedBu, wizard, strings, globalStyles}: any) => ({
  labels: strings.value.pt.authorization,
  labelsIrs: strings.value.pt.IRS,
  buStyles: globalStyles.value,
  selectedBu: selectedBu.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ContainerEmittedDocuments)
);
